import { on_ready, is_elementor_edit } from 'js/utils';
import { hover_intent } from 'js/functions';
import { init_retina } from 'js/retina';

import { init_header } from 'modules/header/header';

// import init_forms from 'modules/forms/forms';
import init_carousels from 'modules/carousel/carousel';
import init_nav_menu from 'modules/menu/nav/nav';

// load global styles
import './main.scss';

import 'modules/footer/footer';
import 'components/admin_bar/init';

on_ready(() => {
	if (is_elementor_edit()) return;

	// init_forms();

	init_header();

	init_nav_menu();

	init_carousels(); // swiper

	init_retina(); // @images

	if (document.querySelector('.slide_menu_open')) {
		import('modules/menu/slide_menu/init');
	}

	init_hover_intent();

	document.dispatchEvent(new Event('after_main_init'));
});

function init_hover_intent() {
	document.querySelectorAll('.hover_intent').forEach((el) => {
		hover_intent(el);
	});
}
